import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-08e960c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "xag-container" }
const _hoisted_2 = { class: "detail-box" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "addr" }, "地址", -1))
const _hoisted_5 = { class: "addr" }
const _hoisted_6 = { class: "map-div" }
const _hoisted_7 = {
  ref: "box",
  class: "map-box"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "phone" }, "联系电话", -1))
const _hoisted_9 = { class: "phone-number xag-flex" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "xag-page__footer" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_header, { title: "网点详情" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.item.company_name), 1),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.item.address), 1),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, null, 512)
        ]),
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", null, _toDisplayString(_ctx.item.phone), 1),
          (_ctx.item.phone)
            ? (_openBlock(), _createBlock(_component_van_icon, {
                key: 0,
                name: "/images/icon_dianhua.svg",
                style: {"margin-left":"8px","margin-top":"4px"},
                onClick: _ctx.onCallPoint
              }, null, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _hoisted_10,
    _createVNode(_component_van_action_sheet, {
      show: _ctx.show,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.show) = $event)),
      actions: _ctx.actions,
      "cancel-text": "取消",
      "close-on-click-action": ""
    }, null, 8, ["show", "actions"])
  ], 64))
}